import { render, staticRenderFns } from "./ProjectOverviewFoerderapp.vue?vue&type=template&id=6be7719d"
import script from "./ProjectOverviewFoerderapp.vue?vue&type=script&lang=ts"
export * from "./ProjectOverviewFoerderapp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports